import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchTripList(filters) {
  try {
    const response = await axios.post(API_URL + endpoints.trip.list, {...filters,trip_mode:"daily"})
    return response.data
  } catch (error) {
    throw error
  }
}
export async function fetchActivePickupTrips() {
  try {
    const response = await axios.post(API_URL + endpoints.trip.activeList, {trip_type: 'pickup'})
    return response.data
  } catch (error) {
    throw error
  }
}
export async function fetchActiveDropTrips() {
  try {
    const response = await axios.post(API_URL + endpoints.trip.activeList, {trip_type: 'drop'})
    return response.data
  } catch (error) {
    throw error
  }
}
export async function fetchTripListOfStudent(studentId) {
  try {
    const response = await axios.get(API_URL + endpoints.trip.studentTripList + studentId)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function fetchStudentsInTrip(tripId) {
  try {
    const response = await axios.put(API_URL + endpoints.trip.studentsInTrip, {
      trip_id: tripId,
    })
    return response.data
  } catch (error) {
    throw error
  }
}
export async function addStudentToTrip(payload) {
  try {
    const response = await axios.post(API_URL + endpoints.trip.addStudentToTrip, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function removeStudentFromTrip(payload) {
  try {
    const response = await axios.post(API_URL + endpoints.trip.removeStudentFromTrip, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createTrip(body) {
  try {
    const response = await axios.post(API_URL + endpoints.trip.create, {...body,trip_mode:"daily"})
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateTrip(body) {
  try {
    const response = await axios.post(API_URL + endpoints.trip.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteTrip(tripId) {
  try {
    const response = await axios.delete(API_URL + endpoints.trip.delete + tripId)
    return response.data
  } catch (error) {
    throw error
  }
}
